
import {
    SEARCH_RESULT
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case SEARCH_RESULT:
        return action.payload
      default:
        return state
    }
  }
